/**
 * A simple convenience wrapper around the native `fetch`.
 */
class HTTPClient {
  async put(url: string, data: object | null): Promise<Response> {
    const body = data ? JSON.stringify(data) : null;

    const response = await fetch(url, {
      method: "PUT",
      body,
      headers: {
        "Content-Type": "application/json",
      },
    });

    return this.handleResponse(response);
  }

  async post(url: string, data: object | null): Promise<Response> {
    const body = data ? JSON.stringify(data) : null;

    const response = await fetch(url, {
      method: "POST",
      body,
      headers: {
        "Content-Type": "application/json",
      },
    });

    return this.handleResponse(response);
  }

  async delete(url: string) {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return this.handleResponse(response);
  }

  private async handleResponse(response: Response): Promise<Response> {
    if (!response.ok) {
      return Promise.reject(response);
    }

    return response;
  }
}

export default new HTTPClient();
